// Bots & API-Tokens – Menüeinträge für die Shell (Integrator bindet sie in extras/index.tsx ein).
import type { ExtraMenuItem } from '../index';
import { BotsAndTokensSettings } from './BotsAndTokensSettings';

export { BotsAndTokensSettings };

export const botsMenuItems: ExtraMenuItem[] = [
  { id: 'bots-tokens', label: 'Bots & API-Tokens', slot: 'userSettings', component: BotsAndTokensSettings, display: 'tab' },
];
